import { render, staticRenderFns } from "./testTips.vue?vue&type=template&id=c5969c3e&scoped=true&"
import script from "./testTips.vue?vue&type=script&lang=js&"
export * from "./testTips.vue?vue&type=script&lang=js&"
import style0 from "./testTips.vue?vue&type=style&index=0&id=c5969c3e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5969c3e",
  null
  
)

export default component.exports